import { Injectable } from '@angular/core';
import { TypeDelaisDivers } from '../../models/TypeDelaisDivers';

@Injectable({
  providedIn: 'root'
})
export class DelaisService {

  constructor() {
  }

  public getDelais(controls): TypeDelaisDivers {
    const delais = new TypeDelaisDivers();
    delais.receptCandidatures = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_TypeDelaisDivers_SepAtt_receptCandidatures'));
    delais.receptionOffres = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_TypeDelaisDivers_SepAtt_receptionOffres'));
    return delais;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
